import { render, staticRenderFns } from "./Order-detail.vue?vue&type=template&id=ada3494a"
import script from "./Order-detail.vue?vue&type=script&lang=js"
export * from "./Order-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports